module.exports = __webpack_public_path__ + "static/img/code-of-life-2.8dee717.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/code-of-life-2.jpg
// module id = izeb
// module chunks = 1